import { useAuth } from '../../context/AuthProvider'
import { Navigate, Outlet } from "react-router-dom"
import { Toggle } from '../Toggle';
import { useTheme } from '../ThemeContext';
import { Box } from '@mui/material';

export default function SuperProtectedRoutes() {
    const { user } = useAuth()
    const { isDarkMode, toggleDarkMode } = useTheme(); // Obtener isDarkMode y toggleDarkMode del ThemeContext

    // Si no hay usuario, redirigir a /login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Si el usuario no es Administrador, redirigir a /home
    if (user?.data?.rol !== 'Administrador') {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Outlet />
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 8,
                    right: 8,
                    zIndex: 1201, // Por encima de la NavBar (AppBar usa zIndex: 1200 por defecto)
                    padding: 1,
                    color: isDarkMode ? 'white' : 'black',
                }}
            >
                <Toggle isChecked={isDarkMode} handleChange={toggleDarkMode} />
            </Box>
        </>
    )
}